import {useState} from 'react';
import toast from 'react-hot-toast';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import AvatarUpload from '../../../components/AvatarUpload';

import Api from '../../../utils/Api';

const CreateList = ({ onCancel, onNext }) => {
  const [name, setName] = useState('');
  const [eventDate, setEventDate] = useState(null)
  const [image, setImage] = useState('');
  const isSubmitOk = name !== '';

  const save = async () => {
    if (isSubmitOk) {
      const [error, list] = await Api.createList({ name, eventDate, image });
      if (error) {
        toast.error(Api.error(error));
        console.error(error);
      } else {
        onNext(list, `Your list ${list.name} was created!`);
      }
    }
  }

  return (
    <div className='step'>
      <div>
        Create New List
      </div>
      <input placeholder='New list name' value={name} onChange={e => setName(e.target.value)} />
      <div>Add an image (optional)</div>
      <AvatarUpload onUploaded = {setImage}/>
      <div>Add a date (optional)</div>
      <DatePicker selected={eventDate} onChange={(date) => setEventDate(date)} />
      <div className='buttons'>
        <button className='danger' onClick={onCancel}>Cancel</button>
        <button disabled={!isSubmitOk} className='primary' onClick={save}>Next</button>
      </div>
    </div>
  )
}

export default CreateList;